<template>
  <div>
    <v-row no-gutters align="center">
      <v-col>
        <ListToolbar
          slot="history-list-toolbar"
          :statistic="{
            value: getTotal,
          }"
          i18nLabel="device.history.operation"
          :state="historyListState"
          :statisticDataState="historyListState"
          :paginationStart="getNavigationConfiguration.start"
          :elementsPerPage="getNavigationConfiguration.size"
          :numberOfElements="getTotal"
          :isLastPage="getNavigationConfiguration.isLastHistoryPage"
          @page-navigation-handler="pageNavigationHandler"
          @go-to-page="navigateToPage"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import { MasterAccountInfo } from 'ctp-user-auth-service';
import { IHistoryState, INavigation, store } from '@/store/modules/history/types';
import { store as userStore } from '@/store/modules/user/types';
import ListToolbar from '@/components/common/ListToolbar/ListToolbar.vue';

@Component({
  components: {
    ListToolbar
  }
})
export default class HistoryToolbar extends Vue {
  @userStore.Getter
  private getSelectedMasterAccount: MasterAccountInfo;

  @store.Getter
  private getTotal!: number;

  @store.Getter
  private getHistoryState!: IHistoryState;

  @store.Getter
  private getNavigationConfiguration!: INavigation;

  @store.Action
  private fetchHistory: (configuration: INavigation | void) => Promise<void>;

  @store.Action
  private updateNavigation!: (payload: INavigation) => void;

  @store.Action
  private historyNavigation!: (params: { direction: 'forward' | 'backward' }) => void;

  private get historyListState(): { [key: string]: boolean } {
    return {
      fetched: this.getHistoryState.fetched.history,
      loading: this.getHistoryState.loading.history,
      error: this.getHistoryState.error.history
    };
  }

  private navigateToPage(page: number) {
    const current = this.getNavigationConfiguration;
    const next = {
      ...current,
      start: page * current.size - current.size
    };
    this.updateNavigation(next);
  }

  private pageNavigationHandler(direction: 'forward' | 'backward') {
    this.historyNavigation({
      direction
    });
  }

  @Watch('getNavigationConfiguration.start', { immediate: true })
  private onNavigationChanged() {
    this.fetchHistory(this.getNavigationConfiguration);
  }

  @Watch('getSelectedMasterAccount', { immediate: true, deep: true })
  private onMasterChange() {
    const account = this.getSelectedMasterAccount;
    if (account.name) {
      this.fetchHistory(this.getNavigationConfiguration);
    }
  }
}
</script>
<style lang="scss" scoped>
@import './styles/history-toolbar.scss';
</style>
